// extracted by mini-css-extract-plugin
export var modal = "_tj-0";
export var table = "_tj-1";